/* @flow */
import * as React from 'react';
import { graphql } from 'react-apollo';

import Button from 'components/Button.jsx';
import DeviceItem from 'settings/components/DeviceItem.jsx';
import devicesQuery from 'settings/queries/devicesQuery.gql';
import Divider from 'components/Divider.jsx';
import Legend from 'components/Legend.jsx';
import LinkSmsDeviceModal from 'user/components/LinkSmsDeviceModal.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import NewEmailDeviceForm from 'settings/components/NewEmailDeviceForm.jsx';
import TextAppLinkForm from 'user/components/TextAppLinkForm.jsx';

export type GQLDevice = {
  __typename: 'Device' | 'PendingSmsDevice',
  id: number,
  label: ?string,
  type: DeviceType,
  enabled: boolean,
  verified: boolean,
  phone_support: ?boolean,
  deliverable: boolean,
  is_preferred_voice_calls_device: boolean,
  endpoint: string,
  osVersion: ?string,
  model: ?string,
  appVersion: ?string,
  reachabilityInfo: {
    reasonShort: ?string,
    reasonLong: ?string,
  },
};

type Props = {
  data: ReactApolloData<DevicesQuery>,
  showSmsDevices: boolean,
};

class DeviceSettings extends React.Component<Props> {
  renderDevice = (device: $Shape<GQLDevice>) => {
    const enabledDevices = this.props.data.devices.filter(d => d.enabled);
    const onlyOneEnabledDevice = enabledDevices ? enabledDevices.length === 1 : undefined;

    const emailDevices = this.props.data.devices.filter(d => d.type === 'email');
    const onlyOneEmail = emailDevices ? emailDevices.length === 1 : undefined;

    return (
      <DeviceItem
        device={device}
        key={device.id}
        onlyOneEmail={onlyOneEmail}
        onlyOneEnabledDevice={onlyOneEnabledDevice}
        refetch={this.props.data.refetch}
      />
    );
  };

  render() {
    const { devices, loading, me } = this.props.data;
    if (loading) {
      return null;
    }
    const pushDevices = devices.filter(d => d.type === 'apns' || d.type === 'gcm');
    const emailDevices = devices.filter(d => d.type === 'email');
    const smsDevices = devices.filter(d => d.type === 'sms');

    return (
      <div className="DeviceSettings">
        <div>
          <Legend>
            Push notifications
            <p>Send and receive messages instantly on your phone.</p>
          </Legend>
          {pushDevices.length === 0 && <TextAppLinkForm />}
          {pushDevices.length !== 0 && pushDevices.map(this.renderDevice)}
        </div>

        {this.props.showSmsDevices && (
          <div>
            <Divider />
            <Legend>Text notifications</Legend>
            <div>{smsDevices.map(this.renderDevice)}</div>
            <div>{me && me.pendingSmsDevices.map(this.renderDevice)}</div>
            <ModalTrigger modal={<LinkSmsDeviceModal onDone={this.props.data.refetch} />}>
              <Button
                size="xsmall"
                level="text"
                color="brand"
                eventElementName="DeviceSettings-addSmsDeviceBtn">
                Add a mobile device
              </Button>
            </ModalTrigger>
          </div>
        )}

        <Divider />

        <Legend>Email notifications</Legend>
        <div>{emailDevices.map(this.renderDevice)}</div>
        <NewEmailDeviceForm onSubmit={this.props.data.refetch} />
      </div>
    );
  }
}

const withData = graphql(devicesQuery);

export { DeviceSettings };
export default withData(DeviceSettings);
